export default "__VITE_PUBLIC_ASSET__ec9d7530__"